import { type FC, type MouseEvent as ReactMouseEvent, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { Button } from '@nxt-costco-com/forge-components';
import { SpaceSm } from '@nxt-costco-com/forge-design-tokens';
import type { ButtonBoxProps } from 'src/components/CookieSettings/ButtonBox/types';
import { AppActionTypes } from 'src/types';

export const ButtonBox: FC<ButtonBoxProps> = ({ dispatch, showAcceptAll }: ButtonBoxProps) => {
    const { t } = useTranslation('translation', { keyPrefix: 'buttonBoxDrawer' });
    const initShowAcceptAllRef = useRef(showAcceptAll);

    const handleClickAcceptAll = (e: ReactMouseEvent<HTMLButtonElement>) => {
        dispatch({ type: AppActionTypes.ACCEPT_ALL, mouseEvent: e });
    };

    const handleClickConfirmMyChoices = (e: ReactMouseEvent<HTMLButtonElement>) => {
        dispatch({ type: AppActionTypes.CONFIRM_MY_CHOICES, mouseEvent: e });
    };

    let content;
    if (initShowAcceptAllRef.current) {
        content = <>
            <Button variant="primary" onClick={handleClickAcceptAll} sx={{ width: '100%' }}>
                {t('acceptAll')}
            </Button>

            <Button variant="secondary" onClick={handleClickConfirmMyChoices} sx={{ width: '100%' }}>
                {t('confirm')}
            </Button>
        </>
    } else {
        content =
            <Button  variant="primary" onClick={handleClickConfirmMyChoices} sx={{ width: '100%' }}>
                {t('confirm')}
            </Button>
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: SpaceSm,
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 0 20px 0',
                width: '100%',
            }}
        >
            { content }
        </Box>
    );
};
